<template>
  <div class="a11y-modal">
    <div class="title">
      <h2>Here are a few things to know to help you get started:</h2>
    </div>

    <div class="body">
      <h3 class="question">What is BetterMynd?</h3>
      <p>
        BetterMynd is an online therapy platform that allows you to
        have
        <b>50-minute teletherapy sessions</b>
        and
        <b>Wellbeing Workshops</b>
        with our diverse network of licensed mental health counselors.
      </p>
      <h3 class="question">How do I pay for sessions?</h3>
      <p>
        Each campus provides their users with a limited number of session credits
        that can be used to pay for your BetterMynd sessions. One (1) credit is equal
        to one (1) session.
      </p>
      <p>
        You currently have
        {{ sessionCreditsAllowed }}
        individual session
        {{ sessionCreditsAllowed === 1 ? 'credit' : 'credits' }}
        and
        {{ workshopCreditsAllowed }}
        Wellbeing Workshops
        {{ workshopCreditsAllowed === 1 ? 'credit' : 'credits' }}
        available to you.
      </p>
      <h3 class="question">What if I run out of credits?</h3>
      <p>
        Users who have utilized all their session credits are able to continue
        working with their BetterMynd counselor by paying out-of-pocket (using a
        credit card), for any additional sessions at a rate of ${{ sessionCost }} per session.
      </p>
      <h3 class="question">
        What if I cancel my session or I'm unable to attend my session?
      </h3>
      <p>
        You can cancel or reschedule any session up to 24-hours before its scheduled
        start time and receive a full refund. If you do not show up to your session
        or cancel it within the 24-hour window, your account will still be charged.
      </p>
    </div>

    <div class="actions">
      <button type="button" @click="$modal.close()">Ok</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreditExplanationModal',

  data() {
    return {
      sessionCreditsAllowed: 0,
      workshopCreditsAllowed: 0,
      sessionCost: 85.00,
      workshopCost: 35.00,
    }
  },

  mounted() {
    const user = this.$store.getters.currentUser;
    const credits = user.student_profile.credits_remaining;

    this.workshopCreditsAllowed = credits.group_session_credits_remaining;
    this.sessionCreditsAllowed = credits.individual_session_credits_remaining;
  },
};
</script>

<style lang="scss" scoped>
h3.question {
  color: $black;
  font-family: Open Sans,sans-serif;
  font-size: 16px;
  margin: 20px 0 4px 0;
}
.a11y-modal div.title {
  padding: 10px 20px 0px 20px;
  border-bottom: 0px
}
div.body {
  margin: 0 24px 0 24px;

  p {
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: 14px;
  }
}
</style>
